'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HeaderRegion;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HeaderRegionStyled = require('./styles/HeaderRegionStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  spread: _propTypes2.default.bool,
  horizontalAlign: _propTypes2.default.oneOf(['start', 'end', 'center', 'space-between', 'space-around']),
  /** Set content align along vertical axis */
  verticalAlign: _propTypes2.default.oneOf(['stretch', 'center', 'start', 'end', 'baseline']),
  size: _propTypes2.default.oneOf(['blank', 'dense', 'default'])
};

var defaultProps = {
  spread: false,
  horizontalAlign: 'start',
  verticalAlign: 'stretch',
  size: 'default'
};

function HeaderRegion(props) {
  return _react2.default.createElement(
    _HeaderRegionStyled.HeaderRegionStyled,
    {
      spread: props.spread,
      horizontalAlign: props.horizontalAlign,
      verticalAlign: props.verticalAlign,
      size: props.size
    },
    props.children
  );
}

HeaderRegion.propTypes = propTypes;
HeaderRegion.defaultProps = defaultProps;
HeaderRegion.displayName = 'HeaderRegion';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-header/dist/HeaderRegion/HeaderRegion.js
// module id = 696
// module chunks = 0